
export default {
	props: {
		rating: {
			type: Number,
			required: true,
		},
		reviewCount: {
			type: String,
			required: true,
		},
		storeName: {
			type: String,
			required: true,
		},
		reviewText: {
			type: String,
			required: true,
		},
	},
	computed: {
		stars() {
			let rating = this.rating;
			const stars = [];
			while (rating > 0) {
				if (rating >= 1) {
					stars.push(1);
					rating -= 1;
				} else {
					stars.push(rating);
					rating = 0;
				}
			}

			return stars;
		},
	},
};
